/*
    Main JS for the website
 */
import './bundle.ts'; // Frontaly js / CSS

// libraries - dependencies
import 'bootstrap/js/dist/modal.js';

import { initContact } from './contact/contact.ts';
import { initGrantSelectPanel } from './grant-select-panel.ts';

initContact();
initGrantSelectPanel();
